import React, { memo } from 'react'
import { DefaultComponent, OptionsWithoutResolver } from '@loadable/component'
import RadialSpinner from 'transfix-ui/components/RadialSpinner'
import Box from 'transfix-ui/core/Box'
import { IDelayOptions, loadableComponent as loadableComponentBase } from 'utils/loadable'

const FallbackComponent = memo(() => {
  return (
    <Box p={4} display='flex' alignItems='center' justifyContent='center'>
      <RadialSpinner position='relative' size='small' />
    </Box>
  )
})

const DEFAULT_PAGE_OPTIONS: OptionsWithoutResolver<any> & IDelayOptions = {
  fallback: <FallbackComponent />,
  delay: 0,
}

/**
 * Creates an async import with some defaults specific to Shipment Details page
 * @see https://loadable-components.com/docs/code-splitting/
 * @note Imported module must have a default export
 * @example
 * ```
 * const AmQuotingToolIndexAsync = loadableComponent(() => import('./index'), { fallback: <div>Loading...</div> })
 * ```
 */
function loadableComponent<Props>(
  loadFn: (props: Props) => Promise<DefaultComponent<Props>>,
  options?: OptionsWithoutResolver<Props> & IDelayOptions
) {
  return loadableComponentBase(loadFn, { ...DEFAULT_PAGE_OPTIONS, ...options })
}

export default loadableComponent
